export const DISABLE_TOP_YMAL_PDP = 'disableTopYmalPdp';
export const SOLD_PDP_V3 = 'increaseEngagementSoldPdpV3';
export const MW_MW_PDP_SHIFTS = 'MW_PDP_Shifts_JAN25';
export const INCORPORATE_ML_YMAL = 'PDP_MlSimilarityModelYmalMoreFromSeller_Apr2025';
export const PDP_DESKTOP_AGGREGATION_FEB_2025 = 'PDPDesktopAggregation_Feb2025';
export const PDP_SPACING_OPTIMIZATION = 'desktopPdpSpacingOptimizations';
